import {
  dockerLogSeverity,
  HIGHLIGHT_TONE_CLASS,
  LOG_LINE_CLASS,
  splitDockerLogHighlights,
} from '../../utils/adminDockerLog';

export default function AdminDockerLogLine({ line, searchQuery = '', dimmed = false }) {
  const sev = dockerLogSeverity(line);
  const rowClass = dimmed ? LOG_LINE_CLASS.dimmed : LOG_LINE_CLASS[sev] || LOG_LINE_CLASS.neutral;
  const parts = splitDockerLogHighlights(line, searchQuery);

  return (
    <div className={`whitespace-pre-wrap break-words border-l-2 pl-2 py-px ${rowClass}`}>
      {parts.map((part, i) => {
        const cls = HIGHLIGHT_TONE_CLASS[part.tone] || HIGHLIGHT_TONE_CLASS.default;
        if (!cls) {
          return <span key={`${i}-${part.text.slice(0, 12)}`}>{part.text}</span>;
        }
        return (
          <span key={`${i}-${part.text.slice(0, 12)}`} className={cls}>
            {part.text}
          </span>
        );
      })}
    </div>
  );
}
